<template>
  <b-card title="Item Discount">
    <item-discount-filter @filtersUpdated="filtersChangeHandler" />
    <item-discount-list :filters="filters" />
  </b-card>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'
import dateMixin from '@/mixins/dateMixin'
import ItemDiscountList from '@/components/Sales/ItemDiscount/ItemDiscountList.vue'
import ItemDiscountFilter from '@/components/Sales/ItemDiscount/ItemDisountFilter.vue'

export default {
  components: {
    BCard,
    ItemDiscountFilter,
    ItemDiscountList,
  },
  mixins: [dateMixin],
  data() {
    return {
      filters: {},
    }
  },
  methods: {
    filtersChangeHandler(filterData) {
      this.filters = filterData
    },
  },
}

</script>
